import React, { lazy, Suspense } from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import ProjectNavigation from "../components/ProjectNavigation"

// Lazy load the ResponsiveImage component
const ResponsiveImage = lazy(() => import("../components/ResponsiveImage"))

const NikeATA = () => {
    // Define images array with all presentation slides in order
    const presentationSlides = Array.from({ length: 19 }, (_, i) => 
        `/images/projects/Nike ATA/FSF 25_Page_${String(i + 1).padStart(2, '0')}`
    )
    
    // Function to create an open in new tab button
    const OpenInNewTabButton = ({ imagePath }) => (
        <a 
            href={`${imagePath}.webp`}
            target="_blank" 
            rel="noopener noreferrer"
            className="open-in-new-tab-btn"
        >
            Open in new tab
        </a>
    )

    // Full-bleed wrapper (lets slides span the full viewport width)
    const fullBleedStyle = {
        width: "100vw",
        marginLeft: "calc(50% - 50vw)",
        marginRight: "calc(50% - 50vw)",
    }

    const fullBleedInnerStyle = {
        paddingLeft: "20px",
        paddingRight: "20px",
        boxSizing: "border-box",
    }

    // Loading placeholder
    const LoadingPlaceholder = () => (
        <div style={{
            width: "100%",
            height: "500px",
            backgroundColor: "#f5f5f5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>
            <div style={{ 
                width: "50px", 
                height: "50px", 
                border: "3px solid #f3f3f3",
                borderTop: "3px solid #000",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
            }} />
        </div>
    )

    return (
        <div>
            <Header />
            <ProjectNavigation currentProject="/nike-ata" />
            
            <div style={{
                textAlign: "center",
                padding: "30px 0 20px",
                marginBottom: "10px"
            }}>
                <h1 style={{ 
                    fontSize: "32px",
                    margin: "0",
                    fontWeight: "bold"
                }}>Fashion Scholarship Fund 2025 - Nike "Attire for All" Case Study</h1>
            </div>

            <main>
                <div style={{ 
                    padding: "20px",
                    maxWidth: "1200px", 
                    margin: "0 auto"
                }}>
                    <div style={{ 
                        display: "flex",
                        flexDirection: "column",
                        gap: "40px",
                        marginBottom: "50px"
                    }}>
                        {presentationSlides.map((image, index) => (
                            <div key={`slide-${index}`}>
                                <div style={fullBleedStyle}>
                                    <div
                                        style={{
                                            ...fullBleedInnerStyle,
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "auto",
                                            margin: "0 auto",
                                            width: "100%",
                                        }}
                                    >
                                        <Suspense fallback={<LoadingPlaceholder />}>
                                            <ResponsiveImage 
                                                src={`${image}.webp`}
                                                alt={`Nike ATA presentation slide ${index + 1}`}
                                                style={{
                                                    width: "100%",
                                                    height: "auto",
                                                    objectFit: "contain"
                                                }}
                                                priority={index === 0}
                                                loading={index < 3 ? "eager" : "lazy"}
                                                sizes="100vw"
                                            />
                                        </Suspense>
                                    </div>
                                    <div
                                        style={{
                                            ...fullBleedInnerStyle,
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            width: "100%",
                                            margin: "0 auto"
                                        }}
                                    >
                                        <OpenInNewTabButton imagePath={image} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default NikeATA